import {
  messageResponseSchema,
  messageTemplatesResponseSchema,
  newConversationResponseSchema,
  type Message,
  type MessageTemplatesResponse,
  type NewConversationBody,
  type NewConversationResponse,
  type SendTemplate,
} from '@chatapp-inbox/shared';
import { request } from './http';

/**
 * Os modelos de mensagem APROVADOS do provedor (`supported: false` = o provedor não tem modelos). O
 * servidor consulta a Meta ao vivo e guarda a lista por 1 minuto.
 */
export function listMessageTemplates(signal?: AbortSignal): Promise<MessageTemplatesResponse> {
  return request('/message-templates', {
    schema: messageTemplatesResponseSchema,
    ...(signal ? { signal } : {}),
  });
}

/**
 * Envia um modelo numa conversa que já existe (vale com a janela de 24 h fechada). `values` leva
 * um texto por variável (`body:1`, `header:1`…). O `clientId` torna o pedido idempotente.
 */
export async function sendTemplateMessage(params: {
  conversationId: string;
  template: SendTemplate;
  clientId: string;
}): Promise<Message> {
  const { message } = await request(
    `/conversations/${encodeURIComponent(params.conversationId)}/messages`,
    {
      method: 'POST',
      body: { template: params.template, clientId: params.clientId },
      schema: messageResponseSchema,
    },
  );
  return message;
}

/**
 * Começa uma conversa com um modelo. Se já havia conversa com esse número e a pessoa pode escrever
 * nela, o modelo vai nela (`created: false`); senão o servidor recusa com `409 conversation_exists`.
 */
export function startConversation(params: NewConversationBody): Promise<NewConversationResponse> {
  return request('/conversations', {
    method: 'POST',
    body: params,
    schema: newConversationResponseSchema,
  });
}
